import store from '../store';
import loadBaseInfo from './baseInfoHelpers';

// export const checkAuthHook = async (to, from, next) => {
export default async (to, from, next) => {
  console.log(window.location.hostname, to.name);
  if (window.location.hostname === 'login.tvoyklass.com' && to.name === 'login') {
    // домен login.tvoyklass.com - специальный для восстановления пароля без
    // привязки к домену. Используется для мобильного приложения. Поэтому логин здесь запрещаем
    return next({
      path: '/auth/restorePassword',
    });
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // этот путь требует авторизации, проверяем загружена ли
    // информация по аккаунту. Если нет, попробуем загрузить ее.
    if (!store.getters.accountData) {
      // Если не авторизованный, пробуем запросить данные, если ошибка, то на логин.
      try {
        await loadBaseInfo();
      } catch (e) {
        next({
          path: '/auth/login',
          query: { redirect: to.fullPath },
        });
      }
      next();
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.loadBaseInfo) && !store.getters.accountData) {
    // Роут не требует авторизации, но данные все равно запросим
    try {
      await loadBaseInfo();
    } finally {
      next();
    }
  } else {
    next();
  }
};
